import { parseNumber } from '../../utils/number'
import { pieceCountFromCommodity, type Commodity } from './Commodity'
import { type ShippingItem } from './ShippingItem'

/** Line item fields used for piece totals (domain `ShippingItem` and presentation `HandlingUnit`). */
export type ShippingItemForPieceCount = {
  packageCount?: string | number
  commodities?: Commodity[]
}

/**
 * Sum of commodity piece counts for one handling unit; if that sum is 0,
 * falls back to the HU packageCount (legacy / empty commodity rows).
 */
export function sumPieceCountForShippingItem(item: ShippingItemForPieceCount): number {
  const commodities = item.commodities ?? []
  const fromCommodities = commodities.reduce(
    (sum, commodity) => sum + pieceCountFromCommodity(commodity),
    0
  )
  return fromCommodities || (parseNumber(item.packageCount) || 0)
}

export function sumPieceCountForShippingItems(shippingItems: ShippingItem[]): number {
  return shippingItems.reduce((total, item) => total + sumPieceCountForShippingItem(item), 0)
}
